import React, { useState, useEffect, useRef } from "react"
import { usePost } from '~/contexts/PostContext'

import * as bstyle from "~/styles/blog/blog.module.scss"

const QuickCaption = ({ copy, styles }) => {
  const { props } = usePost()
  const { quickProds, quickColorOOS, onQuick } = props

  const capsRef = useRef(null)

  const chop_copy = (copy) => {
    const splitRegex = /(<a\s+href="[^"]*">[^<]*<\/a>)/g;
    let split_copy = copy.split(splitRegex).filter(Boolean)
    return split_copy
  }

  const splits = chop_copy(copy)
  const [arr, setArr] = useState([])
  const [didLoad, setDidLoad] = useState(false)

  const check_copy = () => {
    let new_arr = splits.map(x => {
      if (!(x.includes('href=') && x.includes('/products/')) ) {
        return x
      } 

      const linkRegex = /href="([^"]*)"/;
      const textRegex = />([^<]*)<\/a>/;
      let url = x.match(linkRegex)[1]
      const text = x.match(textRegex)[1]

      let handle = ''
      if (url.includes('/products/')) {
        url = url.replace('https://www.buckmason.com/','/')
        handle = url.split('/products/')[1]
        handle = handle.split('?')[0]
        handle = handle.replace('/','')
      }

      const quick_obj = quickProds.find(x => x.handle === handle)
      if (quick_obj) {
        return ` <a href="${url.replace('https://www.buckmason.com/','/')}" class="${bstyle.qbtn}" quick="${quick_obj.prod_mid}" aria-label="Open quick shop for ${text}">${text.trim()}</a>`
      }

      const oos = quickColorOOS.find(x => x.handle === handle)
      if (oos) {
        return ` <a href="${url.replace('https://www.buckmason.com/','/')}" class="${bstyle.qbtn}" quick="${oos.replace_id}" aria-label="Open quick shop for ${text}">${text.trim()}</a>`
      }
      
      return text
    })

    setArr(new_arr)
    setDidLoad(true)
  }

  const quickClick = (e) => {
    if (!e.target.hasAttribute('quick')) return
    e.preventDefault()
    e.stopImmediatePropagation()
    const id = e.target.getAttribute('quick')
    if (id) onQuick(parseInt(id))
  }

  useEffect(() => {
    if (quickProds.length < 1) return
    check_copy()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickProds])

  useEffect(() => {
    if (!didLoad || !capsRef.current) return

    capsRef.current.addEventListener('click', quickClick)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [didLoad])


  return (
    <>
      <div className={styles} ref={capsRef} dangerouslySetInnerHTML={{ __html: arr.join('') }} />
    </>
  )
}

export default QuickCaption




